import * as _ from "lodash";

function getRewardPosition(reward: any): number {
  const rawPosition = reward && reward.position;
  const hasNumericPositionType =
    typeof rawPosition === "number" ||
    (typeof rawPosition === "string" && rawPosition.trim() !== "");
  const position = hasNumericPositionType
    ? Number(rawPosition)
    : Number.NaN;

  return Number.isInteger(position) && position >= 0
    ? position
    : Number.POSITIVE_INFINITY;
}

export function orderRewardsByPosition(rewards: any): any[] {
  if (!_.isArray(rewards)) {
    return [];
  }

  return _.orderBy(_.cloneDeep(rewards), [getRewardPosition], ["asc"]);
}
